"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const core_1 = require("react-hook-schema/core");
const fieldWrapper_1 = require("./common/fieldWrapper");
const displayWrapper_1 = require("./common/displayWrapper");
const media_1 = require("./media");
const upload_1 = require("./media/upload");
const react_hook_form_1 = require("react-hook-form");
const FileSchemaComponent = (props) => {
    const { field: nameField } = (0, react_hook_form_1.useController)({
        name: props.schema.nameFieldPath || "",
        control: props.control,
    });
    const { field: fileField } = (0, react_hook_form_1.useController)({
        name: props.schema.fileFieldPath || "",
        control: props.control,
    });
    const { registerProps, value, fieldState } = (0, core_1.useField)(props, [
        core_1.requiredValidator,
    ]);
    const { schema } = props;
    const { rootPath, maxHeight, accept } = schema;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(fieldWrapper_1.FieldWrapper, { fieldState: fieldState },
            react_1.default.createElement(upload_1.Upload, Object.assign({}, registerProps, { onChange: (value) => {
                    registerProps.onChange(value);
                    const searchParams = new URLSearchParams(value || "");
                    const name = searchParams.get("name");
                    nameField.onChange((name === null || name === void 0 ? void 0 : name.replace(/\s*(?:のコピー| - コピー)?(?:\s*\([0-9]+\)|[0-9]+)*\.[a-zA-Z0-9]+$/, "")) || "");
                }, value: value, rootPath: rootPath, hasError: fieldState.invalid, mode: "filename", onFile: (file) => {
                    fileField.onChange(file);
                }, accept: accept, disposition: "attachment" }))),
        react_1.default.createElement(media_1.File, { style: { border: "1px solid #ccc", maxHeight }, src: value })));
};
FileSchemaComponent.display = (0, displayWrapper_1.DisplayComponent)("FileDisplayComponent", (value, schema) => {
    const { maxHeight } = schema;
    return react_1.default.createElement(media_1.File, { style: { backgroundColor: "#fff", maxHeight }, src: value });
});
exports.default = FileSchemaComponent;
